const esPortal = {
  common: {
    language: 'Idioma',
    english: 'Ingles',
    spanish: 'Espanol',
    workOrders: 'Ordenes de trabajo',
    documents: 'Documentos',
    directions: 'Indicaciones',
    cancel: 'Cancelar',
    close: 'Cerrar',
    save: 'Guardar',
    saving: 'Guardando...',
    generating: 'Generando...',
    submitting: 'Enviando...',
    uploading: 'Subiendo...',
    loadingPhotos: 'Cargando fotos...',
    noPhotosYet: 'Todavia no hay fotos',
    recentPhotos: 'Fotos recientes',
    projectPhotos: 'Fotos del proyecto',
    opportunities: 'Oportunidades',
    poweredBy: 'Con tecnologia de Level Up Roofing CRM',
    reviewedOn: 'Revisado {{date}}',
    expiresOn: 'Vence {{date}}',
    submittedOn: 'Enviado {{date}}',
    tbd: 'Pendiente',
    yes: 'Si',
    no: 'No',
    qtyFallback: 'cant.',
    languageToggleAria: 'Cambiar el idioma del portal',
  },
  documentsOverview: {
    missing: 'Faltan',
    expiring: 'Por vencer',
    allSet: 'Listo',
  },
  errors: {
    invalidOrExpiredLink: 'Enlace invalido o vencido',
    linkNotFoundTitle: 'Enlace no encontrado',
    linkNotFoundBody: 'Este enlace del portal no es valido o fue revocado. Contacte a su contratista para obtener un enlace nuevo.',
    networkError: 'Error de red',
    requestFailed: 'La solicitud fallo',
    invalidPortalLink: 'Enlace del portal invalido',
    workOrderNotFound: 'No se encontro la orden de trabajo',
    installDateRequired: 'La fecha de instalacion es obligatoria',
    invalidDate: 'La fecha no es valida',
    gutterAcceptInvalidState: 'No se puede aceptar esta orden de trabajo en su estado actual.',
    roofInstallWaitingDate: 'Hay una instalacion de techo pendiente y todavia no tiene fecha programada. Espere a que se confirme la fecha del techo.',
    roofInstallConflict: 'La instalacion de canaletas debe programarse despues de que termine la instalacion del techo el {{date}}.',
    companyCamUnavailable: 'CompanyCam no esta configurado para este proyecto.',
    generateInviteFailed: 'No se pudo generar el enlace de invitacion.',
    onlyPdfFilesAllowed: 'Solo se permiten archivos PDF.',
    noFileUploaded: 'No se subio ningun archivo.',
    invoiceUploadFailed: 'La carga fallo.',
    invoiceUploadInvalidState: 'Las facturas solo se pueden subir para ordenes programadas o en espera de pago.',
    requestPaymentInvalidState: 'Esta orden debe estar programada antes de solicitar pago.',
    paymentAmountRequired: 'Ingrese un monto de pago valido.',
    invoiceRequiredBeforePayment: 'Suba una factura antes de solicitar el pago.',
    acceptFailed: 'No se pudo aceptar la orden de trabajo.',
    requestPaymentFailed: 'No se pudo solicitar el pago.',
    opportunityResponseFailed: 'No se pudo actualizar la oportunidad.',
    workOrderStartInvalidState: 'Esta orden no se puede iniciar en su estado actual.',
    invalidWorkStage: 'La etapa de trabajo no es valida.',
    workOrderSliderLocked: 'Esta orden ya no se puede mover desde el control del portal.',
    finalsPredeterminedOnly: 'El envio de cantidades finales solo esta disponible para ordenes con precios predeterminados.',
    finalsRequireCompleted: 'Las cantidades finales solo se pueden enviar despues de marcar la orden como completada.',
    noPayoutLineItems: 'Esta orden no tiene partidas de pago para enviar.',
    completeBeforeReadyForPayReview: 'Complete la orden antes de moverla a Lista para revision de pago.',
    serverError: 'Error del servidor',
  },
  compliance: {
    title: 'Documentos',
    subtitle: 'Suba o reemplace documentos de cumplimiento para el perfil de su compania.',
    sameInsurancePolicy: 'La compensacion laboral esta en la misma poliza que la responsabilidad general',
    needsAttention: 'Necesita atencion:',
    noFile: 'Todavia no se ha subido ningun archivo.',
    viewCurrentDocument: 'Ver documento actual',
    carrierProvider: 'Aseguradora / Proveedor',
    policyNumber: 'Numero de poliza',
    effectiveDate: 'Fecha de vigencia',
    expirationDate: 'Fecha de vencimiento',
    notesForAdminReview: 'Notas para revision administrativa',
    allowedTypes: 'Permitido: PDF, JPEG o HEIC. Las imagenes subidas se convierten a WEBP.',
    replaceDocument: 'Reemplazar documento',
    uploadDocument: 'Subir documento',
    updated: '{{label}} actualizado.',
    reviewLanguageNote: 'Las notas de revision de oficina todavia pueden aparecer en ingles.',
    definitions: {
      general_liability: {
        label: 'Seguro de responsabilidad general',
        description: 'Certificado de seguro de responsabilidad, detalles de la poliza y vencimiento.',
      },
      workers_comp: {
        label: 'Seguro de compensacion laboral',
        description: 'Certificado de compensacion laboral, datos de la aseguradora y vencimiento.',
      },
      w9: {
        label: 'W-9',
        description: 'Formulario fiscal actual archivado para contabilidad y configuracion de pagos.',
      },
    },
    statusMeta: {
      missing: 'Falta',
      submitted: 'Pendiente',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      expired: 'Vencido',
      expiring_soon: 'Por vencer pronto',
    },
  },
  languageToggle: {
    englishShort: 'EN',
    spanishShort: 'ES',
  },
  subPortal: {
    filters: {
      upcoming: 'Trabajo proximo ({{count}})',
      review: 'Accion / Revision ({{count}})',
      completed: 'Completadas ({{count}})',
      opportunities: 'Oportunidades ({{count}})',
    },
    empty: {
      upcoming: 'No hay ordenes de trabajo proximas',
      review: 'No hay ordenes en revision',
      completed: 'No hay ordenes completadas',
    },
    statusLabels: {
      draft: 'Borrador',
      pending_completion: 'Pendiente de completar',
      in_progress: 'En progreso',
      completed: 'Lista para totales finales',
      calculating_pay: 'Revision de totales por PM',
      pay_review: 'Pago pendiente',
      paid: 'Pagada',
    },
    stages: {
      unstarted: 'Sin iniciar',
      workStarted: 'Trabajo iniciado',
      completed: 'Completado',
      readyForPayReview: 'Listo para revision de pago',
    },
    roofDetails: 'Detalles del techo',
    roofStats: {
      total: 'Total',
      standard: 'Estandar',
      steep: 'Inclinada (>=7/12)',
      squaresUnit: 'cuad.',
      pitch: 'Pendiente',
      squares: 'Cuadros',
      steepChip: 'Inclinada',
    },
    colorLabels: {
      shingleColor: 'Color de teja',
      dripEdgeColor: 'Color del borde de goteo',
    },
    buildingLabels: {
      mainHouse: 'Casa principal',
      house: 'Casa',
      garage: 'Garaje',
      detachedGarage: 'Garaje independiente',
      barn: 'Granero',
      shed: 'Cobertizo',
      addition: 'Ampliacion',
      carport: 'Cochera',
      poolHouse: 'Casa de piscina',
      shop: 'Taller',
      office: 'Oficina',
      porch: 'Porche',
      frontPorch: 'Porche delantero',
      rearPorch: 'Porche trasero',
      buildingNumber: 'Edificio {{number}}',
    },
    payout: {
      roughEstimate: 'Estimado de pago',
      finalWorksheet: 'Hoja de cantidades finales',
      paymentBreakdown: 'Desglose de pago',
      roughEstimateNote: 'Pago estimado segun la tabla guardada de tarifas del subcontratista.',
      finalWorksheetNote: 'Ingrese las cantidades finales instaladas y luego envielas a la oficina para revision.',
      paymentBreakdownNote: 'Las cantidades finales estan bajo revision de la oficina antes de marcar el pago como completo.',
      hideBreakdown: 'Ocultar desglose de pago',
      showBreakdown: 'Mostrar desglose de pago',
      estimateBadge: 'Est.',
      readyBadge: 'Lista',
      finalBadge: 'Final',
      reimburseExtra: 'Reembolso / Extra:',
      notes: 'Notas:',
      finalLineItems: 'Cantidades finales por partida',
      zeroQtyNotice: 'Las filas con cantidad cero se muestran por defecto para que no se pase nada por alto.',
      showZeroLineItems: 'Mostrar partidas en cero',
      tableItem: 'Partida',
      tableEstimated: 'Estimado',
      tableFinal: 'Final',
      reimbursementNotePlaceholder: 'Nota de reembolso...',
      completionNotesPlaceholder: 'Notas opcionales de finalizacion para la oficina...',
      submitFinalQuantities: 'Enviar cantidades finales',
      lineItems: {
        perSquare: 'Cuadros',
        osbInstalled: 'OSB instalado',
        extraLayers: 'Cuadros de capas extra',
        skylights: 'Tragaluces',
        smallChimneyReflash: 'Chimenea pequena - reflasheada',
        largeChimneyReflash: 'Chimenea grande - reflasheada',
        steepPerStep: 'Inclinada (por paso)',
        dump: 'Volteo',
      },
    },
    tasks: 'Tareas',
    taskContent: {
      protectLandscaping: 'Proteger el jardin',
      stageMaterials: 'Preparar materiales',
      tearOffExistingRoof: 'Retirar el techo existente',
      inspectDecking: 'Inspeccionar la plataforma',
      replaceDamagedDecking: 'Reemplazar la plataforma danada',
      installIceWaterShield: 'Instalar membrana de hielo y agua',
      installSyntheticUnderlayment: 'Instalar base sintetica',
      installDripEdge: 'Instalar borde de goteo',
      installStarterStrip: 'Instalar tira inicial',
      installShingles: 'Instalar tejas',
      installRidgeVent: 'Instalar ventilacion de cumbrera',
      installFlashing: 'Instalar tapajuntas',
      haulDebris: 'Retirar escombros',
      cleanUp: 'Limpiar',
      magneticSweep: 'Barrido magnetico',
      takeProgressPhotos: 'Tomar fotos del progreso',
      uploadPhotosToCompanyCam: 'Subir fotos a CompanyCam',
      finalWalkthrough: 'Recorrido final',
      installSkylightSingle: 'Instalar {{count}} tragaluz',
      installSkylightPlural: 'Instalar {{count}} tragaluces',
      selectedUpgradeSections: 'Secciones de mejora seleccionadas: {{sections}}',
    },
    statusCards: {
      finalQuantitiesSubmitted: 'Cantidades finales enviadas',
      finalQuantitiesSubmittedBody: 'La oficina esta revisando las cantidades enviadas.',
      pendingPayout: 'Pago pendiente',
      pendingPayoutBody: 'Sus totales fueron aprobados y ahora estan en cola para pago de oficina.',
      completed: 'Orden de trabajo completada',
      completedBody: 'Esta orden de trabajo fue cerrada por la oficina.',
    },
  },
  gutterPortal: {
    headerSub: 'Portal de canaletas',
    filters: {
      active: 'Activas ({{count}})',
      awaiting: 'En espera de pago ({{count}})',
      paid: 'Pagadas ({{count}})',
      opportunities: 'Oportunidades ({{count}})',
    },
    empty: {
      active: 'No hay ordenes activas de canaletas',
      awaiting: 'No hay ordenes de canaletas en espera de pago',
      paid: 'No hay ordenes pagadas',
    },
    statusLabels: {
      draft: 'Nueva',
      pending_install_date: 'Necesita fecha de instalacion',
      scheduled: 'Programada',
      awaiting_payment: 'En espera de pago',
      paid: 'Pagada',
    },
    specs: {
      title: 'Especificaciones de canaletas',
      singleStoryGutters: 'Canaletas 1er piso (LF)',
      secondStoryGutters: 'Canaletas 2do piso (LF)',
      gutterSize: 'Tamano de canaleta',
      downspouts: 'Bajantes',
      secondStoryDownspouts: 'Bajantes 2do piso',
      gutterGuards: 'Protecciones de canaleta (LF)',
      gutterColor: 'Color de canaleta',
      colorFallback: 'Color',
    },
    colorGroups: {
      general: 'General',
    },
    roofInstall: {
      waitingDate: 'La instalacion del techo esta pendiente y espera fecha programada. Todavia no se puede fijar la fecha de canaletas.',
      scheduled: 'La instalacion del techo esta programada y termina el {{date}}. La instalacion de canaletas debe ser despues de esa fecha.',
      completed: 'La instalacion del techo fue completada{{suffix}}.',
      completedSuffix: ' el {{date}}',
      endsLabel: 'El techo termina: {{date}} - elija una fecha posterior.',
    },
    installDate: 'Fecha de instalacion: {{date}}',
    companyCam: {
      projectPhotos: 'Fotos del proyecto en CompanyCam',
      joinProject: 'Unirse al proyecto en CompanyCam',
      linkExpires: 'El enlace vence {{date}}',
      expired: 'Vencido',
      getNewInviteLink: 'Obtener nuevo enlace de invitacion',
      inviteGeneratedAfterAccept: 'El enlace de invitacion se generara cuando acepte esta orden.',
    },
    projectManager: 'Gerente de proyecto:',
    actions: {
      acceptAndSetInstallDate: 'Aceptar y fijar fecha',
      replaceInvoice: 'Reemplazar factura',
      uploadInvoice: 'Subir factura',
      requestPayment: 'Solicitar pago',
    },
    payment: {
      requestSubmitted: 'Solicitud de pago enviada',
      invoiceSubmitted: 'Factura: {{fileName}} - Enviada {{date}}',
      reviewMessage: 'Su solicitud de pago esta siendo revisada.',
      paidTitle: 'Pagada',
      paidBody: 'La oficina ya proceso el pago.',
      requestTitle: 'Solicitar pago',
      requestDescription: 'Ingrese el monto total de su factura.',
      amountPlaceholder: '0.00',
      submitForPayment: 'Enviar para pago',
    },
    acceptModal: {
      title: 'Aceptar y programar',
      description: 'Seleccione su fecha de instalacion de canaletas. La fecha debe ser posterior a cualquier instalacion de techo programada.',
      confirm: 'Confirmar y programar',
      scheduling: 'Programando...',
    },
  },
  opportunities: {
    empty: 'No hay oportunidades disponibles en este momento',
    locationTbd: 'La ubicacion se comparte despues de aceptar',
    schedule: 'Horario sugerido',
    scheduleTbd: 'Horario pendiente',
    estimatedPayout: 'Pago estimado',
    photos: 'Fotos seleccionadas',
    punchList: {
      title: 'Lista de trabajo del equipo',
      description: 'Trabajo esperado incluido con esta oportunidad.',
    },
    measurements: {
      estimatedSquares: 'Cuadros estimados',
      squaresUnit: 'cuad.',
    },
    specLabels: {
      specification: 'Especificacion',
      pitch: 'Pendiente',
      material: 'Material',
      color: 'Color',
      shingleColor: 'Color de teja',
      gutterSize: 'Tamano de canaleta',
      gutterColor: 'Color de canaleta',
      linearFeet: 'Pies lineales',
      downspouts: 'Bajantes',
      stories: 'Pisos',
      layers: 'Capas',
      style: 'Estilo',
      sections: 'Secciones',
      sidingType: 'Tipo de revestimiento',
      panelType: 'Tipo de panel',
      gauge: 'Calibre',
      repairScope: 'Alcance de reparacion',
      windowCount: 'Cantidad de ventanas',
    },
    deadline: {
      title: 'Fecha limite de respuesta',
      respondBy: 'Responder antes de {{date}}',
      expired: 'Vencida',
      daysLeft: 'Quedan {{count}}d',
      hoursLeft: 'Quedan {{count}}h',
      minutesLeft: 'Quedan {{count}}m',
    },
    actions: {
      accept: 'Aceptar',
      decline: 'Rechazar',
      accepting: 'Aceptando...',
      declining: 'Rechazando...',
      confirmAccept: 'Confirmar aceptacion',
      confirmDecline: 'Confirmar rechazo',
      confirmAcceptTitle: 'Aceptar esta oportunidad?',
      confirmDeclineTitle: 'Rechazar esta oportunidad?',
      confirmAcceptBody: 'Actualizaremos su portal despues de aceptar esta oportunidad.',
      confirmDeclineBody: 'Actualizaremos su portal despues de rechazar esta oportunidad.',
    },
    types: {
      roofing: 'Techo',
      flat_roofing: 'Techo plano',
      metal_roofing: 'Techo metalico',
      siding: 'Revestimiento',
      soffit_fascia: 'Sofito / Fascia',
      gutters: 'Canaletas',
      windows: 'Ventanas',
      repairs: 'Reparaciones',
      default: 'Trabajo',
    },
  },
};

export default esPortal;
